var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTincanTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 114,
    viewBox: "0 0 319 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.272 23.9963L316.653 73.44L270.127 90.2382L254.054 43.3301L302.272 23.9963Z",
    fill: "#1F9E54",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.526 40.3509C275.614 42.866 268.817 44.157 263.469 44.261C260.787 44.3132 258.586 44.0638 256.962 43.5949C255.338 43.126 254.532 42.5163 254.163 41.9512C253.794 41.3861 253.647 40.5363 254.153 39.2923C254.658 38.0483 255.751 36.6006 257.458 35.0555C260.862 31.9744 266.412 28.7724 273.323 26.2573C280.234 23.7422 287.031 22.4515 292.379 22.3475C295.061 22.2953 297.262 22.5447 298.886 23.0136C300.51 23.4825 301.316 24.0922 301.686 24.6573C302.054 25.2224 302.201 26.0721 301.695 27.3162C301.19 28.5602 300.097 30.0079 298.39 31.553C294.986 34.634 289.437 37.8358 282.526 40.3509Z",
    fill: "#1F9E54",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.771 91.7474C300.459 89.9111 306.372 87.0094 310.514 83.8897C314.835 80.6348 316.516 77.7326 316.442 75.8043C316.368 73.8759 314.5 71.9485 310.021 71.11C305.728 70.3064 299.717 70.6791 293.03 72.5154C286.342 74.3518 280.43 77.2533 276.288 80.3729C271.967 83.6279 270.285 86.53 270.359 88.4583C270.434 90.3866 272.302 92.3142 276.781 93.1526C281.074 93.9562 287.084 93.5837 293.771 91.7474Z",
    fill: "#A7E05B",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0714 80.2203L2.00002 24.1208L50.7605 5.06133L67.605 58.284L17.0714 80.2203Z",
    fill: "#1F9E54",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2841 59.7752C33.1766 62.8903 27.1027 66.9844 23.0276 71.0031C20.9871 73.0154 19.5249 74.9331 18.6594 76.621C17.7997 78.2975 17.5984 79.5967 17.805 80.585C18.0117 81.5734 18.6771 82.4928 20.0347 83.1975C21.4015 83.9069 23.3531 84.3286 25.8219 84.3645C30.7524 84.4363 37.3751 82.9659 44.4826 79.8509C51.5901 76.7359 57.664 72.6417 61.7391 68.6231C63.7796 66.6107 65.2418 64.693 66.1073 63.0052C66.967 61.3286 67.1684 60.0294 66.9617 59.0411C66.7549 58.0528 66.0897 57.1333 64.732 56.4286C63.3651 55.7192 61.4137 55.2976 58.9448 55.2616C54.0143 55.1898 47.3916 56.6602 40.2841 59.7752Z",
    fill: "#1F9E54",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.826 5.55806C17.8912 8.07666 11.8605 11.4675 7.72251 14.8396C5.64759 16.5304 4.13878 18.1435 3.21488 19.5556C2.29147 20.967 2.07936 21.9671 2.17726 22.6545C2.27528 23.3418 2.73736 24.0972 3.95212 24.7319C5.16759 25.367 6.96503 25.7794 9.29365 25.8709C13.9379 26.0534 20.2938 24.9446 27.2284 22.4261C34.1631 19.9075 40.1941 16.5175 44.3321 13.1455C46.4069 11.4548 47.9158 9.84156 48.8397 8.4295C49.7631 7.01823 49.9751 6.01803 49.8773 5.33062C49.7794 4.64323 49.3173 3.88802 48.1025 3.25317C46.887 2.61804 45.0897 2.20571 42.7609 2.11418C38.1167 1.93169 31.7608 3.03945 24.826 5.55806Z",
    fill: "#A7E05B",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7631 70.2022C54.4404 93.132 89.2598 131.285 135.12 100.457C192.444 61.9219 166.648 5.55268 220.151 2.68645C262.954 0.39346 275.565 21.4762 276.521 32.3042",
    stroke: "#9A6B3F",
    strokeWidth: 4.00004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.96 59.2905C167.297 59.2905 173.247 65.2389 173.247 72.5768C173.247 79.9147 167.298 85.864 159.96 85.864C152.622 85.8638 146.673 79.9146 146.673 72.5768C146.673 65.2391 152.622 59.2907 159.96 59.2905Z",
    fill: "#F2B33D",
    stroke: "#9A6B3F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTincanTelephone);
export default __webpack_public_path__ + "static/media/tincan-telephone.81f0ca6c4deb76cafcdb40699ff6a949.svg";
export { ForwardRef as ReactComponent };